// extracted by mini-css-extract-plugin
module.exports = {"DealLayoutFooter":"DealLayoutFooter_DealLayoutFooter__6_BvO"};